import React, { FC } from 'react';
import { serverSideTranslation } from '../../util/next';
import Page from '../../components/Layout/Page';
import ReportCard from '../../components/ReportCard';
import { getPageContent } from '../../api/pagesApi';
import { getReport, getPolicy, ReportType } from '../../api/reportApi';

import EsgReportCard from '../../components/EsgReportCard';
import NewsFooter from '../../modules/NewsFooter';
import EsgPolicyCard from '../../components/EsgPolicyCard';

interface Props {
  pageContentData: any;
  _nextI18Next: any;
  csrReportList: any;
  esgReportList: any;
  esgPolicyList: any;
}

const Report: FC<Props> = (props) => {
  const { pageContentData, _nextI18Next: i18n, csrReportList, esgReportList, esgPolicyList } = props;

  const { pageContent = {}, shareContent = {} } = pageContentData || {};
  const { reportTitle, csrreportTitle, esgreportTitle, esgPolicyTitle } = pageContent;

  const reportBg = 'https://p0.meituan.net/smartvenus/4d20c8b2bf8a5d951b0a8c0049337634402543.png';
  const style = {
    backgroundImage: `url(${reportBg})`,
  };

  return (
    <Page description={shareContent.shareDetail} title={shareContent.shareTitle} ogImageUrl={shareContent.shareImg}>
      <div className="bg-cover bg-center bg-no-repeat" style={style}>
        <div className="m-auto max-w-screen-xl px-5 xl:px-0">
          {/* 媒体资源标题 */}
          <h2 className="mt-font pt-20 text-xl font-medium leading-6 text-black-dark lg:pt-32 lg:text-4.5xl lg:leading-[3rem]">
            {reportTitle}
          </h2>
          <p className="mb-5 mt-5 text-lg font-medium leading-5 text-black lg:mb-6 lg:mt-10 lg:text-2sm lg:leading-10">
            {csrreportTitle}
          </p>
          <div className="grid h-auto grid-cols-2 gap-4  sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 lg:gap-8 ">
            {csrReportList?.map((item: any, index: any) => {
              return <ReportCard reportCardData={item} key={index} />;
            })}
          </div>
          <p className="mb-5 mt-10 text-lg font-medium leading-5 text-black lg:mb-6 lg:mt-10 lg:text-2sm lg:leading-10">
            {esgreportTitle}
          </p>
          <div className="grid h-auto grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 lg:gap-8 ">
            {esgReportList?.map((item: any, index: any) => {
              return <EsgReportCard EsgreportCardData={item} key={index} />;
            })}
          </div>
          <p className="mb-5 mt-10 text-lg font-medium leading-5 text-black lg:mb-7 lg:mt-10 lg:text-2sm lg:leading-10">
            {esgPolicyTitle}
          </p>
          <div className="grid h-auto grid-cols-1 gap-[0.625rem] pb-15 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 lg:gap-5 lg:pb-25">
            {esgPolicyList?.map((item: any, index: any) => {
              return <EsgPolicyCard EsgPolicyCardData={item} key={index} />;
            })}
          </div>
        </div>
        <div className="bg-white">
          <NewsFooter category="csr" lanType={i18n.initialLocale} positionNo="csr_13" />
        </div>
      </div>
    </Page>
  );
};

export async function getServerSideProps({ locale, query }: any) {
  // 获取下载报告页面的数据
  const pageContentParams = {
    uri: '/csr/report',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  let csrReportList = [];
  let esgReportList = [];
  let esgPolicyList = [];
  const params = { lanType: locale };
  await Promise.all([
    (csrReportList = await getReport({ ...params, reportType: ReportType.CSR_REPORT })),
    (esgReportList = await getReport({ ...params, reportType: ReportType.ESG_REPORT })),
    (esgPolicyList = await getPolicy({ ...params, reportType: ReportType.ESG_POLICY })),
  ]);

  return {
    props: {
      lxCustom: {
        cid: 'c_donation_vyfko6kl',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      csrReportList,
      esgReportList,
      esgPolicyList,
      ...(await serverSideTranslation(locale, ['report', 'cookie', 'common'])),
    },
  };
}

export default Report;
